module.exports = __webpack_public_path__ + "static/media/error-404.3c31639d.svg";